<template>
  <div class="issue-summary">
    <div v-if="!documentView"
         class="summary-header">
      <h2>
        Results
        <span class="bar"></span>
        <em>
          Error Counts
          <span class="count"
                v-if="report.wcagVersion">
            {{ report.totalErrorCount }}
          </span>
          <span class="count"
                v-else>
            {{ report.errorCount }} / {{ report.passCount + report.errorCount }}
          </span>
        </em>
      </h2>
    </div>
    <div class="summary-body">
      <table class="checklist-table">
        <thead>
          <tr>
            <th class="no"></th>
            <th>Checklist</th>
            <th class="number">Result</th>
            <th class="number">Error</th>
<!--            <th class="number">Pass</th>-->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in swasCategory"
              :key="item.showId"
              @click="onCategoryClick(item)">
            <td class="no">{{ item.showId }}</td>
            <td>{{ item.titleEn }}</td>
            <td class="number"
                :class="summaryMap[item.id].resultCssClass">
              <span>{{ summaryMap[item.id].resultType }}</span>
            </td>
            <td class="number">{{ summaryMap[item.id].errorCount }}</td>
<!--            <td class="number">{{ summaryMap[item.id].passCount }}</td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReportSummary',
  props: ['report', 'summaryMap', 'documentView'],
  computed: {
    ...mapGetters(['swasCategory'])
  },
  methods: {
    onCategoryClick (category) {
      this.$emit('onCategoryClick', category)
    }
  }
}
</script>

<style lang="scss" scoped>
.issue-summary {
  border-radius: 10px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  height: 100%;
  overflow: auto;

  .summary-header {
    margin: 15px 19px 21px 19px;

    h2 {
      font-size: 18px;
      font-weight: 600;
      color: #444444;

      .bar {
        width: 1px;
        height: 11px;
        margin: 0 8px;
        background-color: #d7d7d7;
        display: inline-block;
        vertical-align: middle;
      }

      em {
        font-size: 14px;
        color: #ec0047;

        .count {
          display: inline-block;
          vertical-align: middle;
          padding: 3px 5px;
          text-align: center;
          font-size: 12px;
          line-height: 12px;
          height: 12px;
          min-width: 8px;
          border-radius: 10px;
          border: solid 1px #ec0047;
          margin-top: -3px;
          margin-left: 3px;
        }
      }
    }
  }

  .summary-body {
    .checklist-table {
      width: calc(100% - 40px);
      margin: 0 20px 20px 20px;

      th {
        font-size: 13px;
        font-weight: 500;
        color: #666666;
        border-bottom: 2px solid #666666;
        padding: 3px 0;

        &.no {
          width: 30px;
        }

        &.number {
          text-align: center;
          width: 60px;
        }
      }

      td {
        font-size: 15px;
        color: #222222;
        height: 42px;
        border-top: 1px solid #e7e7e7;
        cursor: pointer;
        transition: background-color 0.15s ease;

        &.no {
          font-size: 14px;
          color: #666666;
          text-align: center;
          font-weight: 300;
        }

        &.number {
          font-size: 14px;
          color: #666666;
          text-align: center;
          font-weight: 300;
        }

        &.pass {
          span {
            display: inline-block;
            width: 28px;
            height: 28px;
            background-color: #3eaa08;
            line-height: 28px;
            text-align: center;
            border-radius: 14px;
            font-size: 14px;
            font-weight: 700;
            color: #ffffff;
          }
        }

        &.error {
          span {
            display: inline-block;
            width: 28px;
            height: 28px;
            background-color: #ec0047;
            line-height: 28px;
            text-align: center;
            border-radius: 14px;
            font-size: 14px;
            font-weight: 700;
            color: #ffffff;
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
        }
      }

      tr:hover {
        td {
          background-color: rgba(0, 0, 0, 0.06);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportSummary.vue